module.exports = __webpack_public_path__ + "img/train_black_24dp.da927dd6.svg";